import { useEffect, useRef } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildGetAccountUsersRequest } from './utils';

const useGetAccountUsersByEmails = ({ onSuccess, onError = () => {} }) => {
  const accountId = useCurrentAccountId();
  const paramsRef = useRef();

  const {
    data: accountUsersByEmailsData,
    error: accountUsersByEmailsError,
    doFetch: doAccountUsersByEmailsFetch,
  } = useDataApi();

  const getAccountUsersByEmails = (emails, params) => {
    paramsRef.current = params;

    doAccountUsersByEmailsFetch(
      buildGetAccountUsersRequest({
        accountId,
        search: emails.join(','),
        fields: 'email,defaultRoleId,defaultCompanyId',
        searchByEmailsArray: true,
        includeAllMembers: true,
        equalTextMatch: true,
      })
    );
  };

  useEffect(() => {
    if (accountUsersByEmailsError === null) return;

    onError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountUsersByEmailsError]);

  useEffect(() => {
    if (accountUsersByEmailsData === null) return;

    onSuccess(accountUsersByEmailsData, paramsRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountUsersByEmailsData]);

  return {
    getAccountUsersByEmails,
  };
};

export default useGetAccountUsersByEmails;
